<template>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing" v-if="shouldShowNotification">
        <div class="widget widget-card-three kyc-status-widget" @click="navigateToKYC" :class="{ 'kyc-approved': isKYCApproved }">
            <div class="widget-heading">
                <a :href="isKYCApproved ? mt5Link : 'javascript:void(0)'" class="task-info" :target="isKYCApproved ? '_blank' : null">
                    <svg v-if="!isKYCApproved" style="margin-right: 10px" width="64px" height="64px" viewBox="0 0 1024 1024" class="icon"
                        version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M810.666667 554.666667m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
                            fill="#FFCC80" />
                        <path
                            d="M213.333333 554.666667m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
                            fill="#FFCC80" />
                        <path
                            d="M832 405.333333c0-270.933333-640-177.066667-640 0v213.333334c0 177.066667 142.933333 320 320 320s320-142.933333 320-320V405.333333z"
                            fill="#FFCC80" />
                        <path
                            d="M512 85.333333C324.266667 85.333333 170.666667 238.933333 170.666667 426.666667v74.666666l44.8 12.8V405.333333l416-134.4 174.933333 134.4v108.8l44.8-12.8V426.666667C853.333333 266.666667 738.133333 85.333333 512 85.333333z"
                            fill="#FFCC80" />
                        <path d="M341.333333 512h341.333334v85.333333H341.333333z" fill="#F44336" />
                    </svg>
                    <svg v-else style="margin-right: 10px" width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" fill="#28a745"/>
                        <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div style="margin-left: 10px; margin-right: 10px" >
                        <h5 class="kyc-status-title" :class="{ 'text-success': isKYCApproved }">{{ title }}</h5>
                    </div>
                </a>
            </div>
            <div class="widget-content">
                <p>
                  <template v-if="isKYCApproved">
                    Login to Trading Account - login credentials are sent by email to registered email address.<br>
                    <a :href="mt5Link" target="_blank" style="color: #28a745; text-decoration: underline;">Download MT5</a>
                  </template>
                  <template v-else>
                    {{ content }}
                  </template>
                </p>
                <div class="progress-data"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import '@/assets/sass/widgets/widgets.scss';
import { useRouter, useRoute } from 'vue-router';
import userService from '@/services/user.service';
import errorHandleService from '@/services/errorHandle.service';
import { onMounted, computed, provide, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();
const route = useRoute();

const isKYCApproved = computed(() => {
    return store.state.user?.user_sumsub?.review_status === "completed" && store.state.user?.user_sumsub?.review_result === 1;
});

const shouldShowNotification = computed(() => {
    const blacklistPages = ['faq', 'account.kyc'];
    if (isKYCApproved.value) {
        return route.name === 'dashboard';
    }
    return !blacklistPages.includes(route.name);
});

const title = computed(() => {
    if (isKYCApproved.value) {
        return 'Your KYC has been successfully verified, and your account is now activated.';
    }
    return 'KYC Status: Not Approved!';
});

const content = computed(() => {
    if (isKYCApproved.value) {
        return 'Login to Trading Account - login credentials are sent by email to registered email address.\nDownload MT5';
    }
    return 'KYC approval is required in order to deposit and withdraw funds, open a trading account and trade. Please do the necessary steps from the "Account -> KYC - Documents" link in the menu. If you sent your information and necessary documents, you will be contacted as soon as possible.';
});

const mt5Link = 'https://dynamicmarkets.com/platform';

const navigateToKYC = () => {
    if (isKYCApproved.value) {
        window.open(mt5Link, '_blank');
    } else {
        router.push('/account/kyc');
    }
};

onMounted(() => {
    // Check if user data is loaded
    if (!store.state.user) {
        userService.getUser(store.state.user.id).then((user) => {
            store.commit('setUser', user);
        }).catch((err) => {
            console.error('Error loading user data:', err);
        });
    }
});
</script>

<style scoped>
.kyc-status-widget {
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #e0e6ed;
}

.kyc-status-widget:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.kyc-status-widget:not(.kyc-approved):hover {
    border-color: #f44336;
}

.kyc-status-widget.kyc-approved:hover {
    border-color: #28a745;
}

.kyc-status-title {
    font-weight: 700;
    color: #f44336;
    font-size: 1.25rem;
}

.kyc-status-title.text-success {
    color: #28a745;
}

.widget-content p {
    font-size: 1.1rem;
    font-weight: 500;
    color: #3b3f5c;
    white-space: pre-line;
}
</style>
